<template>
  <v-dialog persistent :value="value" max-width="290">
    <v-card>
      <v-card-title class="headline">
        Delete confirmation
      </v-card-title>
      <v-card-text>
        You are about to delete the result for
        <span class="font-weight-bold">{{
          result && result.sortition && result.sortition.name
        }}</span>
        in date {{ date }}, are you sure?
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="onCancel">
          No
        </v-btn>

        <v-btn color="red darken-1" text @click="onConfirm">
          Yes, delete it.
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { destroyResult } from "../../../api/result.api.js";

export default {
  name: "ResultDeleteDialog",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    result: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onCancel() {
      this.close();
    },
    onConfirm() {
      destroyResult(this.date, this.result.sortition.id)
        .then(() => {
          this.close();
          this.$emit("delete", this.result);
        })
        .catch(() => {
          this.close();
        });
    }
  }
};
</script>

<style scoped></style>
